// Financiación VCARS con La Financiera.
// Se suma un 50% del capital ORIGINAL por cada año de plazo (interés simple, sin sistema francés).
export const ANNUAL_RATE = 0.5; // TNA 50%

export const FINANCING_TERMS = [12, 24, 36, 48, 60];

// Plazo usado para calcular las cuotas aproximadas cuando la planilla no trae la columna CUOTA.
export const DEFAULT_INSTALLMENTS = 48;

const roundCents = (n: number) => Math.round(n * 100) / 100;

/**
 * Total financiado = capital × (1 + 0,50 × años).
 * Ej.: $10.000.000 a 36 cuotas → 10.000.000 × (1 + 0,50 × 3) = $25.000.000
 */
export function calcFinancedTotal(principal: number, months: number, rate: number = ANNUAL_RATE): number {
  if (principal <= 0 || months <= 0) return 0;
  return roundCents(principal * (1 + rate * (months / 12)));
}

/** Cuota = total financiado ÷ cantidad de cuotas. Ej.: 25.000.000 ÷ 36 = $694.444,44 */
export function calcInstallment(principal: number, months: number, rate: number = ANNUAL_RATE): number {
  if (principal <= 0 || months <= 0) return 0;
  return roundCents(calcFinancedTotal(principal, months, rate) / months);
}

/** "50%" */
export function formatRate(rate: number): string {
  return `${(rate * 100).toLocaleString('es-AR', { maximumFractionDigits: 4 })}%`;
}
